import type { RecordOut } from "@/api/generated/Api";
import type { ProfileData } from "./types";

export function buildAudioUrl({
  fileId,
  baseUrl,
  profileId,
}: {
  fileId: string;
  baseUrl: string;
  profileId: string;
}) {
  return `${baseUrl}/v1/profiles/${encodeURIComponent(profileId)}/records/${fileId}`;
}

type RawProfilePayload = { forms?: unknown; records?: unknown };

export function normalizeProfileData(raw: unknown): ProfileData {
  const forms: ProfileData["forms"] = [];
  const records: RecordOut[] = [];

  if (!raw) return { forms, records };

  const payload = raw as RawProfilePayload;
  const rawArray = Array.isArray(raw)
    ? raw
    : Array.isArray(payload.forms)
      ? payload.forms
      : [];
  const rawRecords =
    !Array.isArray(raw) && Array.isArray(payload.records)
      ? payload.records
      : [];

  for (const block of rawArray) {
    if (!block || typeof block !== "object") continue;

    if (block.entity_type === "form") {
      const form: ProfileData["forms"][0] = {
        fio: typeof block.fio === "string" ? block.fio : "Неизвестный",
        telephone:
          typeof block.phone === "string" ? block.phone : "+7 (000) 000-00-00",
        comment: null,
        items: [],
      };

      if (block.entities && typeof block.entities === "object") {
        for (const key in block.entities) {
          const item = block.entities[key];
          if (item.ui_type === "comment") {
            form.comment = { key, item };
          } else {
            form.items.push({ key, item });
          }
        }
      }
      forms.push(form);
    } else if (block.entity_type === "records") {
      if (block.entities && typeof block.entities === "object") {
        for (const key in block.entities) {
          records.push(block.entities[key]);
        }
      }
    }
  }

  for (const record of rawRecords) {
    records.push(record);
  }

  return { forms, records };
}

export function isNonEmptyProfileData(value: unknown): boolean {
  if (!value) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") {
    const payload = value as { forms?: unknown; records?: unknown };
    const hasForms = Array.isArray(payload.forms) && payload.forms.length > 0;
    const hasRecords =
      Array.isArray(payload.records) && payload.records.length > 0;
    return hasForms || hasRecords;
  }
  return false;
}
